<ng-container *ngIf="company; else loadingCompany">
    <section class="profile-subsection">
        <div class="d-flex justify-content-center align-items-center flex-column gap-3">
            <h3 class="m-0">{{ company.name }}</h3>
            <div class="w-100">
                <div class="data-entry">
                    <strong>{{ "Registration number:" | translate }}</strong>
                    <span>{{ company.registrationNumber }}</span>
                </div>
                <div class="data-entry">
                    <strong>{{ "VAT Number:" | translate }}</strong>
                    <span>{{ company.vatNumber }}</span>
                </div>
                <div class="data-entry">
                    <strong>{{ "Activity:" | translate }}</strong>
                    <span>{{ company.activity | translate }}</span>
                </div>
                <div class="data-entry" *ngIf="company.activity === 'real_estate'">
                    <strong>{{ "company_activity.real_estate.pro_number" | translate }}</strong>
                    <span>{{ company.proNumber }}</span>
                </div>
                <div class="data-entry" *ngIf="company.activity === 'real_estate'">
                    <strong>{{ "company_activity.real_estate.authorization_number" | translate }}</strong>
                    <span>{{ company.authorizationNumber }}</span>
                </div>
                <div class="data-entry" *ngIf="company.activity === 'car_dealership'">
                    <strong>{{ "company_activity.car_dealership.authorization_number" | translate }}</strong>
                    <span>{{ company.authorizationNumber }}</span>
                </div>
                <div class="text-center" *ngIf="user?.type === 'pro'">
                    <button (click)="changeCompanyInfo()" class="btn btn-link">{{ "Edit" | translate }}</button>
                </div>
            </div>
        </div>
    </section>

    <div class="separator my-4"></div>

    <section class="profile-subsection">
        <h3>{{ "Documents" | translate }}</h3>
        <ng-container *ngIf="documents; else loadingDocument">
            <ng-container *ngIf="documents.length === 0; else documentsList">
                <p class="m-0">{{ "No documents" | translate }}</p>
            </ng-container>
            <ng-template #documentsList>
                <div class="table-responsive">
                    <table class="table documents-table">
                        <thead>
                            <tr>
                                <th>{{ "Document type" | translate }}</th>
                                <th>{{ "Expiry date" | translate }}</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let d of documents">
                                <td>{{ getLabelFromType(d.type) | translate }}</td>
                                <td class="text-nowrap">{{ d.expiresAtFormatted }}</td>
                                <td>
                                    <div class="d-flex justify-content-end align-items-center gap-2">
                                        <button class="btn btn-link-primary" (click)="downloadDocument(d)">
                                            <i class="bi bi-cloud-download clickable"></i>
                                        </button>
                                        <button class="btn btn-link-danger" (click)="deleteDocument(d)">
                                            <i class="bi bi-trash clickable"></i>
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </ng-template>
        </ng-container>
        <ng-template #loadingDocument>
            <div class="text-center py-4"><app-loader></app-loader></div>
        </ng-template>
        <ng-container *ngIf="canAddDocuments()" [formGroup]="addDocumentForm">
            <div class="separator my-4"></div>
            <h4>{{ "Add documents" | translate }}</h4>
            <div class="row g-3 add-document-form">
                <div class="col-12">
                    <label for="document" class="form-label required">{{ "Document type" | translate }}</label>
                    <select formControlName="type" class="form-select" id="document">
                        <option value="">{{ "Select document type" | translate }}</option>
                        <option *ngFor="let t of documentTypes" [value]="t.value">{{ t.label | translate }}</option>
                    </select>
                </div>
                <div class="col-12" *ngIf="displayExpiresAtField()">
                    <label for="expiresAt" class="form-label required">{{ "Expiry date" | translate }}</label>
                    <input
                        type="date"
                        class="form-control"
                        placeholder="{{ 'Expiry date' | translate }}"
                        formControlName="expiresAt"
                        id="expiresAt"
                    />
                </div>
                <div class="col-12 d-flex justify-content-end">
                    <button
                        type="button"
                        (click)="uploadDocument()"
                        class="btn btn-primary w-100 add-document-btn"
                        [disabled]="addDocumentForm.invalid"
                    >
                        {{ "Pick file" | translate }}
                    </button>
                </div>
            </div>
        </ng-container>
    </section>

    <div class="separator my-4"></div>

    <section class="profile-subsection">
        <h4>{{ "Add team members" | translate }}</h4>
        <p class="m-0">
            {{ "Add team members explanation" | translate }}
        </p>
        <p class="m-0 mt-2">
            <span>{{ "Company code" | translate }}</span> <span class="ps-4 fs-4 fw-bold">{{ company.code }}</span>
        </p>
    </section>
</ng-container>
<ng-template #loadingCompany>
    <div class="text-center py-4"><app-loader></app-loader></div>
</ng-template>
